import React from "react"

const TONES = {
  emerald: "bg-emerald-500",
  blue:    "bg-blue-500",
  amber:   "bg-amber-500",
  rose:    "bg-rose-500",
  slate:   "bg-slate-400",
  brand:   "bg-blue-600",
}

const toneFor = (value, override) => {
  if (override) return TONES[override] || TONES.slate
  if (value >= 100) return TONES.emerald
  if (value >= 70)  return TONES.blue
  if (value >= 30)  return TONES.amber
  return TONES.slate
}

const ProgressBar = ({ value = 0, tone, height = 6, showLabel = false, className = "" }) => {
  const clamped = Math.max(0, Math.min(100, Number(value) || 0))
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex-1 rounded-full bg-slate-100 overflow-hidden" style={{ height }}>
        <div className={`h-full rounded-full ${toneFor(clamped, tone)}`} style={{ width: `${clamped}%` }} />
      </div>
      {showLabel && (
        <span className="text-[11px] text-slate-500 tabular-nums w-9 text-right">{Math.round(clamped)}%</span>
      )}
    </div>
  )
}

export default ProgressBar
